export const onlyDecimals = e => {
  let k = e.keyCode
  if ((k >= 48 && k <= 57) || k === 8 || k === 110 || k === 190 || k === 37 || k === 39 || (k >= 96 && k <= 105)) {
    return true
  } else {
    e.preventDefault()
  }
}
export const onlyNumbers = e => {
  let k = e.keyCode
  if ((k >= 48 && k <= 57) || k === 8 || k === 37 || k === 39 || (k >= 96 && k <= 105)) {
    return true
  } else {
    e.preventDefault()
  }
}
export const stringToJson = string => {
  if (string) {
    return JSON.stringify(string.split(','))
  } else {
    return null
  }
}
export const jsonImage = (data, size = 'thumb') => {
  let image = JSON.parse(data)
  return image.images[size]
}
export const backgroundImage = (json, size = 'thumb') => {
  let images = JSON.parse(json)
  let img = images.images[size]
  return 'background-image: url(' + img + ')'
}
export const reportSet = cols => {
  cols = JSON.parse(cols)
  let data = []
  cols.forEach(column => {
    column['values'] = []
    data.push(column)
  })
  return data
}
export const nl2br = (str, is_xhtml) => {
  if (typeof str === 'undefined' || str === null) {
      return '';
  }
  var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
}
function addZeroToLeft (value, len) {
  let v = value.toString()
  for (let index = v.length; index < len; index++) {
    v = '0' + v
  }
  return v
}
export const defaultDateFormat = date => {
  let year = date.getFullYear()
  let month = addZeroToLeft(date.getMonth() + 1, 2)
  let day = addZeroToLeft(date.getDate(), 2)
  return year + '-' + month + '-' + day
}
export const defaultTimeFormat = time => {
  let hour = addZeroToLeft(time.getHours(), 2)
  let minutes = addZeroToLeft(time.getMinutes(), 2)
  let seconds = addZeroToLeft(time.getSeconds(), 2)
  return hour + ':' + minutes
}



// WEBPACK FOOTER //
// ./src/core/libs/functions.js